<div class="offer-container" #LocTermApprovalComponent>
    <!-- TODO: Maybe refactor this to better responsive layout? -->
    <!-- [ngClass]="{'tiny': width < 900}" (window:resize)="onResize(false)"> -->

    <div class="tw-mt-1">
        <div *ngFor="let benefit of approval?.benefits; let i=index" class="tw-mt-1.5 tw-mb-1 tw-inline-block">
            <span *ngIf="i<3" class="
          border
          bg-success
          tw-text-white
          tw-rounded-t-md
          tw-font-extralight
          tw-px-2
          tw-pt-1
          tw-pb-2">
                {{ benefit?.title }}
                <mat-icon matTooltip="{{ benefit?.description }}" matTooltipPosition="above"
                    class="mat-info-icon align-middle">info_outline
                </mat-icon>
            </span>
        </div>
    </div>

    <mat-expansion-panel class="mat-elevation-z" [expanded]="initializeExpanded || !cardExpandable" [togglePosition]="cardExpandable ? 'before' : ''" [hideToggle]="!cardExpandable" [disabled]="!cardExpandable">
        <mat-expansion-panel-header *ngIf="!hideHeader" class="loc-term-approval-expansion-header">
            <mat-panel-title>
                <div class="tw-flex">
                    <div>
                        <div class="tw-font-medium">{{ approval?.name }}</div>
                        <div class="text-secondary">{{ approval?.loanProductName }}</div>
                    </div>

                    <div class="pl-2">
                        <div *ngIf="approval.isTest"
                            class="test-indicator-label px-2 bg-secondary tw-text-white font-bold">
                            Test
                        </div>
                    </div>
                </div>
            </mat-panel-title>
            <mat-panel-description>
                <div class="tw-flex justify-content-start approval-field-container"
                    data-cy="approval-field-container">
                    <!-- LIMIT -->
                    <div data-cy="approval-field">
                        <div *ngIf="calculationType === 'loc'"
                             class="text-center approval-field-header text-secondary max-amount-header">LIMIT</div>
                        <div *ngIf="calculationType === 'term'"
                             class="text-center approval-field-header text-secondary max-amount-header">AMOUNT</div>
                        <div class="text-center font-weight-bold">
                            {{ maxOption?.limits.drawAmount.max | currency:'USD':'symbol':'1.0-0' }}
                        </div>
                    </div>
                    <!-- TERM -->
                    <div data-cy="approval-field">
                        <div class="text-center approval-field-header text-secondary max-amount-header">TERM</div>
                        <div class="text-center font-weight-bold">{{ maxOption?.term }}</div>
                    </div>
                    <!-- CENTS / $ -->
                    <div data-cy="approval-field">
                        <div class="text-center approval-field-header text-secondary max-amount-header"><span class="font-mono tw-pr-1">~</span> CENTS / $</div>
                        <div class="text-center font-weight-bold">{{ staticCentsOnTheDollar }}</div>
                    </div>
                    <!-- APR -->
                    <div data-cy="approval-field">
                        <div class="text-center approval-field-header text-secondary max-amount-header">RATE</div>
                        <div class="text-center font-weight-bold">{{ this.annualRate | number : '1.2-2' }}%</div>
                    </div>
                    <!-- STIPS -->
                    <div data-cy="approval-field">
                        <div class="text-center approval-field-header text-secondary max-amount-header">STIPS</div>
                        <div class="text-center font-weight-bold">{{ stipulationCount }}</div>
                    </div>
                    <!-- POINTS -->
                    <div data-cy="approval-field">
                        <div class="text-center approval-field-header text-secondary header max-amount-header">POINTS
                        </div>
                        <div class="text-center font-weight-bold">{{ maxOption?.limits.points.max }}</div>
                    </div>
                </div>
            </mat-panel-description>

           <app-approval-menu-smart
             class="tw-flex"
             [approval]="approval"
             [hideCreateOptionButton]="hideCreateOptionButton"
             (createOption)="createOfferOption()"
           >
             <div class="approval-status tw-font-bold">
               Status: <span [class]="{
                  'published-marker__published': isApprovalPublished,
                  'published-marker__unpublished': !isApprovalPublished,
                }">{{ publishedStatus }}</span>
             </div>
             <div class="tw-flex-1 tw-justify-self-end tw-self-center" *ngIf="approval.offerLink">
               <a target="_blank" href="{{approval.offerLink}}">
                 <button
                   data-cy="send-to-bp-btn"
                   mat-button
                   color="primary">
                   Offer Link
                 </button>
               </a>
             </div>
           </app-approval-menu-smart>
        </mat-expansion-panel-header>

        <!-- Content -->
        <div class="relative">
            <div *ngIf="errored" class="error-message">
                <div>
                    <p>
                        There is currently an integration error with <strong>{{ approval.loanProductLender }}</strong>.
                        <span *ngIf="!approval.approvalLink">Calculations for this approval are unavailable at this
                            time.</span>
                        Please contact Lendio product and development.
                    </p>
                    <div *ngIf="approval.approvalLink">
                        To continue calculations for this approval, follow this link:
                        <div>
                            <a href="{{ approval.approvalLink }}" ref="noopener noreferrer nofollow" target="_blank">{{
                                approval.approvalLink }}</a>
                        </div>
                    </div>
                </div>
            </div>

            <ng-container *ngIf="!readOnly else readOnlyView">
                <div [ngClass]="{'error-blur': errored}" *ngIf="!initializing" class="tw-flex tw-flex-row tw-w-full">
                    <div class="tw-p-4 tw-w-full">
                        <div class="tw-grid tw-grid-cols-[1fr_190px] tw-pb-4">
                            <div class="tw-grid tw-gap-4">
                              <!-- Term  -->
                              <div class="tw-grid tw-grid-cols-[25%_1fr] tw-gap-2">
                                <app-restricted-input [label]="'Term'"
                                                      (valueChange)="changeTerm($event)" [value]="selectedTerm" [step]="1"
                                                      [disabled]="disabled || (availableTerms.length <= 1)" [type]="'number'" [min]="minTerm"
                                                      [max]="maxTerm" data-cy="calc-term-input">
                                </app-restricted-input>

                                <app-discrete-slider *ngIf="availableTerms.length > 1"
                                                     (valueChange)="changeTerm($event)" [disabled]="disabled" [thumbLabel]="true"
                                                     [value]="selectedTerm" [marks]="availableTerms">
                                </app-discrete-slider>
                              </div>

                              <!-- Frequency -->
                              <div class="tw-grid tw-grid-cols-[25%_1fr] tw-gap-2">
                                <app-restricted-input [label]="'Frequency'" [disabled]="true"
                                                      [value]="paymentFrequencyDisplay">
                                </app-restricted-input>

                                <app-restricted-radio class="ml-1 pt-1" *ngIf="frequencyOptions.length > 1"
                                                      [options]="frequencyOptions" [availableOptions]="termRestrictedFrequencyOptions"
                                                      [disabled]="disabled" (valueChange)="changePaymentFreq($event)"
                                                      [value]="selectedPaymentFrequency">
                                </app-restricted-radio>
                              </div>
                              <!-- Draw Amount -->
                              <div class="tw-grid tw-grid-cols-[25%_1fr] tw-gap-2">
                                <app-restricted-input [label]="'Draw Amount'"
                                                      [value]="selectedDrawAmount" [disabled]="disabled" [type]="'number'" [min]="minDrawAmount"
                                                      [max]="maxDrawAmount" [step]="100" (valueChange)="changeDrawAmount($event)">
                                </app-restricted-input>

                                <app-restricted-slider [updateContinuously]="true" (mouseup)="calculate()"
                                                       [value]="selectedDrawAmount" [showValues]="true" [currency]="true"
                                                       [showCurrencyDecimals]="false" [tickInterval]="0" [thumbLabel]="true" [disabled]="disabled"
                                                       [step]="1000" [min]="minDrawAmount" [max]="maxDrawAmount" [availableMax]="maxDrawAmount"
                                                       (valueChange)="changeDrawAmount($event)">
                                </app-restricted-slider>
                              </div>

                              <!-- Payoff Months -->
                              <div class="tw-grid tw-grid-cols-[25%_1fr] tw-gap-2">
                                <app-restricted-input [ngClass]="{'early-payoff': isEarlyPayoff}"
                                                      [label]="'Payoff Months'" (valueChange)="changePayoffMonths($event)"
                                                      [value]="selectedPayoffMonths" [step]="1"
                                                      [disabled]="disabled || (availablePayoffMonths.length <= 1)" [type]="'number'"
                                                      [min]="minPayoff" [max]="maxPayoff" data-cy="calc-payoff-input">
                                </app-restricted-input>

                                <app-restricted-slider *ngIf="availablePayoffMonths.length > 1"
                                                       [ngClass]="{'early-payoff': isEarlyPayoff}" [updateContinuously]="true"
                                                       [value]="selectedPayoffMonths" [showValues]="true" [currency]="false"
                                                       [showCurrencyDecimals]="false" [tickInterval]="1" [thumbLabel]="true" [disabled]="disabled"
                                                       [step]="1" [min]="minPayoff" [max]="maxPayoff" [availableMax]="selectedTerm"
                                                       (valueChange)="changePayoffMonths($event)">
                                </app-restricted-slider>
                              </div>
                            </div>
                            <!-- Calculated Data -->
                          <div class="tw-grid tw-gap-2 tw-pl-4">
                            <!-- TODO: Option Data Bullet Entries here -->
                            <div class="tw-grid tw-grid-flow-col tw-justify-between" data-cy="approval-bullet-item">
                              <!-- Limit -->
                              <div class="text-secondary text-right text-nowrap">Limit</div>
                              <div class="tw-min-w-[60px] tw-text-right font-weight-bold animate-loading">
                                {{ maxOption?.limits.drawAmount.max | currency:'USD':'symbol':'1.0-0' }}
                              </div>
                            </div>
                            <!-- Draw Amount -->
                            <div class="tw-grid tw-grid-flow-col tw-justify-between" data-cy="approval-bullet-item">
                              <div *ngIf="calculationType === 'loc'"
                                   class="text-secondary text-right text-nowrap">Draw Amount</div>
                              <div *ngIf="calculationType === 'term'"
                                   class="text-secondary text-right text-nowrap">Amount</div>
                              <div class="tw-tw-min-w-[60px] tw-text-right font-weight-bold animate-loading">
                                {{ selectedDrawAmount | currency:'USD':'symbol':'1.0-0' }}
                              </div>
                            </div>
                            <!-- Annual Rate (Interest Rate) -->
                            <div class="tw-grid tw-grid-flow-col tw-justify-between" data-cy="approval-bullet-item">
                              <div class="text-secondary text-right text-nowrap">Interest Rate</div>
                              <div class="tw-min-w-[60px] tw-text-right font-weight-bold animate-loading">{{
                                this.annualRate| number : '1.2-2' }}%</div>
                            </div>
                            <!-- Periodic Rate -->
                            <div class="tw-grid tw-grid-flow-col tw-justify-between" data-cy="approval-bullet-item">
                              <div class="text-secondary text-right text-nowrap">{{ periodicLabel
                                }} Rate</div>
                              <div class="tw-min-w-[60px] tw-text-right font-weight-bold animate-loading">{{
                                periodicRate | number : '1.2-4' }}%</div>
                            </div>
                            <!-- Payment -->
                            <div class="tw-grid tw-grid-flow-col tw-justify-between" data-cy="approval-bullet-item">
                              <div class="text-secondary text-right text-nowrap">Payment</div>
                              <div class="tw-min-w-[60px] tw-text-right font-weight-bold animate-loading">
                                {{ paymentAmount | currency:'USD':'symbol':'1.0-0' }}
                              </div>
                            </div>
                            <!-- Disbursement -->
                            <div class="tw-grid tw-grid-flow-col tw-justify-between" data-cy="approval-bullet-item">
                              <div class="text-secondary text-right text-nowrap">Disbursement
                              </div>
                              <div class="tw-min-w-[60px] tw-text-right font-weight-bold animate-loading">
                                {{ disbursement | currency:'USD':'symbol':'1.0-0' }}
                              </div>
                            </div>
                            <!-- Draw Fee -->
                            <div class="tw-grid tw-grid-flow-col tw-justify-between" data-cy="approval-bullet-item">
                              <div *ngIf="calculationType === 'loc'"
                                   class="text-secondary text-right text-nowrap">Draw Fee</div>
                              <div *ngIf="calculationType === 'term'"
                                   class="text-secondary text-right text-nowrap">Origination Fee</div>
                              <div class="tw-min-w-[60px] tw-text-right font-weight-bold animate-loading">
                                {{ drawFee | currency:'USD':'symbol':'1.0-0' }}
                              </div>
                            </div>
                            <!-- Commission -->
                            <div class="tw-grid tw-grid-flow-col tw-justify-between" data-cy="approval-bullet-item">
                              <div class="text-secondary text-right text-nowrap">Commission</div>
                              <div class="tw-min-w-[60px] tw-text-right font-weight-bold animate-loading">
                                {{ commission | currency:'USD':'symbol':'1.0-0' }}
                              </div>
                            </div>
                            <!-- APR -->
                            <div class="tw-grid tw-grid-flow-col tw-justify-between" data-cy="approval-bullet-item">
                              <div class="text-secondary text-right text-nowrap"><span class="font-mono tw-pr-1">~</span> APR</div>
                              <div class="tw-min-w-[60px] tw-text-right font-weight-bold animate-loading">{{ apr
                                }}%</div>
                            </div>
                            <!-- Offer Link -->
                            <div *ngIf="hasOfferCuration && approval.offerLink" class="tw-grid tw-grid-flow-col tw-justify-between" data-cy="approval-bullet-item">
                              <div class="text-secondary text-right text-nowrap">Offer Link</div>
                              <div class="tw-min-w-[60px] tw-text-right font-weight-bold animate-loading">
                                <a target="_blank" href="{{ approval.offerLink }}">Offer Link</a>
                              </div>
                            </div>
                          </div>
                        </div>

                      <table mat-table class="tw-w-full" [dataSource]="paybackDataSource">
                        <ng-container matColumnDef="payoffType">
                          <mat-header-cell *matHeaderCellDef class="!tw-max-w-[220px] !tw-text-sm  !pl-0 !pr-5"></mat-header-cell>
                          <mat-cell *matCellDef="let element" class="!tw-max-w-[220px] !tw-text-sm !pl-0 !pr-5">{{ element.payoffType }}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="payback">
                          <mat-header-cell *matHeaderCellDef class="!tw-max-w-[140px] !tw-text-sm !pl-0 !pr-5">
                            <span class="font-mono tw-pr-1">~</span>Payback
                          </mat-header-cell>
                          <mat-cell  *matCellDef="let element" class="!tw-max-w-[140px] !tw-text-sm !pl-0 !pr-5">{{ element.payback | currency:'USD':'symbol':'1.0-0' }}
                            <div *ngIf="element.payoffType==='Selected Payoff:' && isEarlyPayoff" class="delta-payoff">
                              <mat-icon class="mat-icon-arrow">arrow_downward</mat-icon>{{ paybackChanged | currency:'USD':'symbol':'1.0-0' }}
                            </div>
                          </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="costOfCapital">
                          <mat-header-cell *matHeaderCellDef class="!tw-max-w-[140px] !tw-text-sm !pl-0 !pr-5">
                            <span class="font-mono tw-pr-1">~</span>Cost of Capital
                          </mat-header-cell>
                          <mat-cell  *matCellDef="let element" class="!tw-max-w-[140px] !tw-text-sm !pl-0 !pr-5">{{ element.costOfCapital | currency:'USD':'symbol':'1.0-0' }}
                            <div *ngIf="element.payoffType==='Selected Payoff:' && isEarlyPayoff" class="delta-payoff">
                              <mat-icon class="mat-icon-arrow">arrow_downward</mat-icon>{{ costOfCapitalChanged | currency:'USD':'symbol':'1.0-0' }}
                            </div>
                          </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="cents">
                          <mat-header-cell *matHeaderCellDef class="!tw-max-w-[140px] !tw-text-sm !pl-0 !pr-5">
                            <span class="font-mono tw-pr-1">~</span>Cents/$
                          </mat-header-cell>
                          <mat-cell  *matCellDef="let element" class="!tw-max-w-[140px] !tw-text-sm !pl-0 !pr-5">{{ element.cents }}
                            <div *ngIf="element.payoffType==='Selected Payoff:' && isEarlyPayoff" class="delta-payoff">
                              <mat-icon class="mat-icon-arrow">arrow_downward</mat-icon>{{ centsOnTheDollarChanged }}
                            </div>
                          </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="payments">
                          <mat-header-cell *matHeaderCellDef class="!tw-max-w-[110px] !tw-text-sm !pl-0 !pr-5">
                            <span># Payments</span>
                          </mat-header-cell>
                          <mat-cell  *matCellDef="let element" class="!tw-max-w-[110px] !tw-text-sm !pl-0 !pr-5">{{ element.payments }}
                            <div *ngIf="element.payoffType==='Selected Payoff:' && isEarlyPayoff" class="delta-payoff">
                              <mat-icon class="mat-icon-arrow">arrow_downward</mat-icon>{{ numberOfPaymentsChanged }}
                            </div>
                          </mat-cell>
                        </ng-container>
                        <mat-header-row *matHeaderRowDef="displayedColumns" class="!px-6"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: displayedColumns"
                                 class="!px-6 !py-1">
                        </mat-row>
                      </table>

                    </div>
                </div>
            </ng-container>

            <ng-template #readOnlyView>
              <div class="tw-grid tw-grid-cols-[30%_1px_1fr] tw-gap-2.5 tw-p-4">
                <ng-container *ngTemplateOutlet="calculated"></ng-container>
                <mat-divider [vertical]="true"></mat-divider>
                <div class="tw-grid">
                  <ng-container *ngTemplateOutlet="stipulations"></ng-container>
                </div>
              </div>
            </ng-template>
        </div>
    </mat-expansion-panel>
</div>

<ng-template #calculated>
  <!-- Calculated Data -->
  <div>
    <!-- Limit -->
    <div class="tw-grid tw-grid-flow-col tw-justify-between">
      <span>Limit</span>
      <span>{{ maxOption?.limits.drawAmount.max | currency:'USD':'symbol':'1.0-0' }}</span>
    </div>
    <!-- Draw Amount -->
    <div class="tw-grid tw-grid-flow-col tw-justify-between">
      <span *ngIf="calculationType === 'loc'">Draw Amount</span>
      <span *ngIf="calculationType === 'term'">Amount</span>
      <span>{{ selectedDrawAmount | currency:'USD':'symbol':'1.0-0' }}</span>
    </div>
    <!-- Annual Rate (Interest Rate) -->
    <div class="tw-grid tw-grid-flow-col tw-justify-between">
      <span>Interest Rate</span>
      <span>{{ this.annualRate| number : '1.2-2' }}%</span>
    </div>
    <!-- Periodic Rate -->
    <div class="tw-grid tw-grid-flow-col tw-justify-between">
      <span>{{ periodicLabel }} Rate</span>
      <span>{{ periodicRate | number : '1.2-4' }}%</span>
    </div>
    <!-- Payment -->
    <div class="tw-grid tw-grid-flow-col tw-justify-between">
      <span>Payment</span>
      <span>{{ paymentAmount | currency:'USD':'symbol':'1.0-0' }}</span>
    </div>
    <!-- Disbursement -->
    <div class="tw-grid tw-grid-flow-col tw-justify-between">
      <span>Disbursement</span>
      <span>{{ disbursement | currency:'USD':'symbol':'1.0-0' }}</span>
    </div>
    <!-- Draw Fee -->
    <div class="tw-grid tw-grid-flow-col tw-justify-between">
      <span *ngIf="calculationType === 'loc'">Draw Fee</span>
      <span *ngIf="calculationType === 'term'">Origination Fee</span>
      <span>{{ drawFee | currency:'USD':'symbol':'1.0-0' }}</span>
    </div>
    <!-- Commission -->
    <div class="tw-grid tw-grid-flow-col tw-justify-between">
      <span>Commission</span>
      <span>{{ commission | currency:'USD':'symbol':'1.0-0' }}</span>
    </div>
    <!-- APR -->
    <div class="tw-grid tw-grid-flow-col tw-justify-between">
      <span><span class="font-mono tw-pr-1">~</span> APR</span>
      <span>{{ apr }}%</span>
    </div>
    <!-- Payback -->
    <div class="tw-grid tw-grid-flow-col tw-justify-between">
      <span><span class="font-mono tw-pr-1">~</span> Payback</span>
      <span>{{ paybackMax | currency:'USD':'symbol':'1.0-0' }}</span>
    </div>
    <!-- Payments -->
    <div class="tw-grid tw-grid-flow-col tw-justify-between">
      <span># Payments</span>
      <span>{{ numberOfPayments }}</span>
    </div>
    <!-- Offer Link -->
    <div *ngIf="hasOfferCuration && approval.offerLink" class="tw-grid tw-grid-flow-col tw-justify-between">
      <span>Offer Link</span>
      <a target="_blank" href="{{ approval.offerLink }}">Offer Link</a>
    </div>
  </div>
</ng-template>
